import { createApp } from 'vue'  // Import createApp from 'vue'
import App from './index.vue'       // Import the main App component
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';    // Import our custom CSS
createApp(App).mount('#app')    // Create and mount the app to the #app element
